<template>
    <div id="pie" ref="pie"></div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    props: {
      pieDataProps: {
        type: Array,
        default: []
      },
      pieObj: {
        type: Object,
        default: {}
      },
      pieTitleProps: {
        type: String,
        default: ''
      },
      seriesRadiusProps: {
        type: Array,
        default: () => ['40%', '70%']
      },
    },
    data() {
        return {
          myChart: null,
          pieData: [],
        }
    },
    mounted() {
        this.myChart = echarts.init(this.$refs.pie);
        this.init();
        window.addEventListener("resize", this.handleWindowResize);
    },
    watch: {
        pieDataProps: {
            handler(newValue) {
                // console.log(newValue,'newValue')
                if(newValue){
                    let newData = [];
                    newValue.forEach(element => {
                        newData.push({
                            name: element[this.pieObj.key],
                            value: element[this.pieObj.value]
                        })
                    });
                    this.pieData = newData
                    this.init();
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        init() {
            this.$nextTick(() => {
                    // color: ['#00BBFF','#6a6da9','#585eaa','#494e8f','#9b95c9','#6950a1','#6f60aa','#867892','#6f6d85','#6f599c','#8552a1','#543044','#63434f',],
                    // color: [
                    // '#00BBFF','#70f3ff','#3eede7','#1685a9','#177cb0','#065279','#003472','#4b5cc4','#a1afc9','#CCCCFF','#F0BBFF','#FFB7DD','#FFCCCC',
                    // '#f7acbc','#ef5b9c','#f05b72','#f69c9f','#f58f98','#ca8687','#d64f44','#b3424a','#bb505d','#f3715c','#840228','#892f1b','#f3704b',
                    // '#deab8a','#fedcbd','#f47920','#905a3d','#8f4b2e','#87481f','#faa755','#f58220','#905d1d','#826858','#705628','#cd9a5b','#b36d41',
                    // '#817936','#80752c','#87843b','#454926','#2e3a1f','#b7ba6b','#b2d235','#5c7a29','#7fb80e','#769149','#78a355','#74905d','#77ac98',
                    
                    let option = {
                      title: {
                        show: true,
                        text: this.pieTitleProps,
                        left: 'center'
                      },
                      tooltip: {
                        // trigger: 'item'
                      },
                      legend: {
                        bottom: '5%',
                        left: 'center',
                        type: 'scroll'
                      },
                      series: [
                        {
                          name: this.pieTitleProps,
                          type: 'pie',
                          radius: this.seriesRadiusProps,
                          avoidLabelOverlap: false,
                          label: {
                            show: false,
                            position: 'center'
                          },
                          emphasis: {
                            label: {
                              show: false,
                              fontSize: '18',
                              fontWeight: 'bold'
                            }
                          },
                          labelLine: {
                            show: false
                          },
                          data: this.pieData
                        }
                      ]
                    };

                option && this.myChart.setOption(option);
            })
            
        }, 
        handleWindowResize() {
            if (!this.myChart) return;
            this.myChart.resize();
        },
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleWindowResize);
    },
}



</script>
<style scoped>
#pie {
    width: 100%;
    height: 100%;
}
</style>